export default __webpack_public_path__ + "static/media/injector-group.838bdf31.png";